<template>
  <div :class="['OfferCardBrand']" @click.stop="$emit(`click`)">
    <BaseIcon :class="iconSize" :size="iconSize" :name="iconName" />
  </div>
</template>

<script>
import BaseIcon from '~/aasgard/components/base/BaseIcon.vue'

export default {
  name: 'OfferCardBrand',
  components: { BaseIcon },
  props: {
    iconName: {
      type: String,
      required: true,
    },
    iconSize: {
      type: String,
      default: 'md',
      validator(value) {
        return ['sm', 'md'].includes(value) || value === 'md'
      },
    },
  },
  emits: ['click'],
}
</script>

<style lang="scss">
.OfferCardBrand {
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
  background-color: $color-neutral-light;
  width: 32px;
  height: 32px;
  overflow: hidden;
  border-radius: 100px;
}
</style>
